var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.licValidate && _vm.licStatus !== "no_record"
    ? _c("div", { staticClass: "lic" }, [
        _c("strong", [_vm._v(_vm._s(_vm.$t(_vm.licMsg)))]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }